<template>
    <div class="inner with-content with-tables">
        <div class="Headline">
            <h1>{{$t('permissions.headline')}}</h1>
        </div>

        <tabs>
            <tab :name="$t('requests.tabname')">
                <v-client-table :columns="columns" :data="requests" :options="options" ref="table" class="invitations-table">
                    <div slot="beforeFilter" class="intro">
                            <h2>{{$t('requests.headline')}}</h2>
                        </div>
                        <div slot="afterFilter" class="add-button">
                            <div class="icon">
                                <simple-svg
                                    :filepath="'images/SVG/Search.svg'"
                                    :width="'20px'"
                                    :height="'20px'"

                                />
                            </div>
                        </div>
                        <div slot="name" class="data-label" :data-label="$t('permissions.table.name.label')" slot-scope="props">{{ props.row.name }}</div>
                        <div v-if="props.row.company" slot="company" class="data-label" :data-label="$t('permissions.table.company.label')" slot-scope="props">{{ props.row.company }}</div>
                        <div slot="date" class="data-label" :data-label="$t('permissions.table.date.label')" slot-scope="props">{{ props.row.date }}</div>
                        <a slot="more" slot-scope="props">
                            <table-dropdown>
                                <li>{{$t('dropdown.accept')}}</li>
                                <li>{{$t('dropdown.reject')}}</li>
                            </table-dropdown>
                        </a>
                </v-client-table>
            </tab>
            <tab :name="$t('with-access.tabname')">
                <v-client-table :columns="columns" :data="withAccess" :options="options" ref="table" class="invitations-table">
                    <div slot="beforeFilter" class="intro">
                            <h2>{{$t('with-access.headline')}}</h2>
                        </div>
                        <div slot="afterFilter" class="add-button">
                            <div class="icon">
                                <simple-svg
                                    :filepath="'images/SVG/Search.svg'"
                                    :width="'20px'"
                                    :height="'20px'"

                                />
                            </div>
                        </div>
                        <div slot="name" class="data-label" :data-label="$t('permissions.table.name.label')" slot-scope="props">{{ props.row.name }}</div>
                        <div v-if="props.row.company" slot="company" class="data-label" :data-label="$t('permissions.table.company.label')" slot-scope="props">{{ props.row.company }}</div>
                        <div slot="date" class="data-label" :data-label="$t('permissions.table.date.label')" slot-scope="props">{{ props.row.date }}</div>
                        <a slot="more" slot-scope="props">
                            <table-dropdown>
                                <li>{{$t('dropdown.accept')}}</li>
                                <li>{{$t('dropdown.reject')}}</li>
                            </table-dropdown>
                        </a>
                </v-client-table>
            </tab>
            <tab name="Without Accces" :name="$t('without-access.tabname')">
                <v-client-table :columns="columns" :data="withoutAccess" :options="options" ref="table" class="invitations-table">
                    <div slot="beforeFilter" class="intro">
                            <h2>{{$t('without-access.headline')}}</h2>
                        </div>
                        <div slot="afterFilter" class="add-button">
                            <div class="icon">
                                <simple-svg
                                    :filepath="'images/SVG/Search.svg'"
                                    :width="'20px'"
                                    :height="'20px'"

                                />
                            </div>
                        </div>
                        <div slot="name" class="data-label" :data-label="$t('permissions.table.name.label')" slot-scope="props">{{ props.row.name }}</div>
                        <div v-if="props.row.company" slot="company" class="data-label" :data-label="$t('permissions.table.company.label')" slot-scope="props">{{ props.row.company }}</div>
                        <div slot="date" class="data-label" :data-label="$t('permissions.table.date.label')" slot-scope="props">{{ props.row.date }}</div>
                        <a slot="more" slot-scope="props">
                            <table-dropdown>
                                <li>{{$t('dropdown.accept')}}</li>
                                <li>{{$t('dropdown.reject')}}</li>
                            </table-dropdown>
                        </a>
                </v-client-table>
            </tab>
        </tabs>

<!--         <div class="List">
            <div class="ListTop">
                <div class="Col Candidate">
                    <p class="Label">Landlord</p>
                </div>
                <div class="Col Address">
                    <p class="Label">Address</p>
                </div>
                <div class="Col City">
                    <p class="Label">City</p>
                </div>
                <div class="Col More">
                    <p class="Label">More</p>
                </div>
            </div>
            <div class="ListContent" v-for="invitation in getReceivedInvitations">
                <div class="ListItem">
                    <div class="Col Candidate">
                        <p>{{getFullName(invitation)}}</p>
                    </div>
                    <div class="Col Address">
                        <p>{{getAddress(invitation)}}</p>
                    </div>
                    <div class="Col City">
                        <p>{{getCity(invitation)}}</p>
                    </div>
                    <div class="Col More">
                        <div class="MoreIcon">
                            <img src="images/SVG/Buttons/More.svg" alt="">
                        </div>
                        <button @click.prevent="acceptInvitation(invitation)">Accept</button>
                        <button @click.prevent="rejectInvitation(invitation)">Reject</button>
                    </div>
                </div>

            </div>
        </div> -->
    </div>
</template>
<script>

    import {store} from '../store/index'
    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import {mapGetters} from 'vuex';
    import TableDropdown from '../components/TableDropdown'

    Vue.use(ClientTable);



    Vue.filter('formatDate', function(value) {
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY')
        }
    });

    export default {
        async beforeRouteEnter(to, from, next) {
            await store.dispatch("fetchReceivedInvitations");
            next()
        },
        components:{
            TableDropdown
        },
        data: () => ({
            columns: ['name', 'company', 'date', 'more'],
            options: {
                headings: {
                    name: 'Name',
                    company: 'Company',
                    date: 'Date',
                    more: 'More'
                },
                sortable: ['name'],
                filterable: ['name', 'company'],
                childRowTogglerFirst: false,

                texts:{
                    filterPlaceholder: 'Search',
                    filter: ''
                },
                columnsClasses: {
                    name: 'name',
                    company: 'company',
                    date: 'date',
                    more: 'more'
                }
            },
            links:{
                0: {
                    'link' : '#',
                    'title': 'link title'
                },
                1: {
                    'link' : '#',
                    'title': 'link title'
                }
            }
        }),
        computed: {
            ...mapGetters([
                'getReceivedInvitations'
            ]),
            requests() {
                return this.filterList(0);
            },
            withAccess() {
                return this.filterList(1);
            },
            withoutAccess() {
                return this.filterList(2);
            }
        },
        methods: {
            filterList(status) {
                var list = [];
                for (var i in this.getReceivedInvitations) {
                    if (status != 1) continue;
                    let invite = this.getReceivedInvitations[i];
                    list.push({
                        name: invite.landlord.full_name,
                        date: moment(String(invite.created_at)).format('DD-MM-YYYY')
                    });
                }
                return list;
            },
            getFullName(invite){
                if(invite.user_info.length){
                    return invite.user_info[0].first_name + ' ' + invite.user_info[0].last_name;
                }
                return invite.email;
            },
            getAddress(invite){
                return invite.property.address
            },
            getCity(invite){
                return invite.property.city
            },
            async acceptInvitation(invite){
                await store.dispatch('acceptInvite', invite)
            },
            async rejectInvitation(invite){
                await store.dispatch('rejectInvite', invite)
            }
        },
        created(){
            this.options.headings.name = this.$t('permissions.table.name.label');
            this.options.headings.company = this.$t('permissions.table.company.label');
            this.options.headings.date = this.$t('permissions.table.date.label');
            this.options.texts.filterPlaceholder = this.$t('search.filterplaceholder');
            this.options.texts.noResults = this.$t('table.no-results.label');
        }
    }
</script>

<style scoped>

</style>
